import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { MemulTypeKey } from '@/const/buildingType';
interface LastFilterType {
  lastFilterType: MemulTypeKey;
  setLastFilterType: (filterType: MemulTypeKey) => void;
}

export const useLastFilterStore = create<LastFilterType>()(
  persist(
    (set) => ({
      lastFilterType: 'apt', // "oneroom" | "apt" | "officetel" | "villa" | "redevelop"
      setLastFilterType: (filterType) => set(() => ({ lastFilterType: filterType })),
    }),
    {
      name: 'LastFilterType',
    },
  ),
);
